import Widgets1 from "Components/CommonWidgets/Widgets1";
import { useMemo } from "react";
import { Col, Row } from "reactstrap";

const WidgetsWrapper = (props: any) => {
  const {} = props;

  const widgetData = useMemo(
    () => [
      {
        title: "Tổng số người vi phạm",
        total: "2,435",
        color: "secondary",
        icon: "stroke-user",
        gros: 30,
      },
      {
        title: "Tổng số hồ sơ vi phạm",
        total: "2,908",
        gros: 30,
        color: "secondary",
        icon: "stroke-user",
      },
      {
        title: "Tổng số tiền thu ngân sách",
        total: "2543",
        color: "primary",
        gros: 15,
        icon: "tag",
      },
      {
        title: "Tổng số tiền chưa thu được",
        total: "390.800.000",
        gros: 40,
        color: "success",
        icon: "rate",
      },
    ],
    [props]
  );
  return (
    <Row>
      <Col xl="3">
        <Widgets1 data={widgetData[0]} />
      </Col>
      <Col xl="3">
        <Widgets1 data={widgetData[1]} />
      </Col>
      <Col xl="3">
        <Widgets1 data={widgetData[2]} />
      </Col>
      <Col xl="3">
        <Widgets1 data={widgetData[3]} />
      </Col>
    </Row>
  );
};

export default WidgetsWrapper;
